<template>
  <div class="container">
    <p id="title">Biodata Diri</p>
    <div class="detail">
      <div class="mb-3">
        <span class="lable">Nama</span>
        <span class="valueLable">{{ this.profile.personName }}</span>
      </div>
      <div class="mb-3">
        <span class="lable">Tanggal Lahir</span>
        <span class="valueLable">{{ dob }}</span>
      </div>
      <div class="mb-3">
        <span class="lable">Jenis Kelamin</span>
        <span class="valueLable">{{
          this.profile.genderCd == "G_MALE" ? "Laki-Laki" : "Perempuan"
        }}</span>
      </div>
      <div class="mb-3">
        <span class="lable">No. KTP</span>
        <span class="valueLable">{{ this.profile.idCardNo }}</span>
      </div>
      <div class="mb-3">
        <span class="lable">Email</span>
        <span class="valueLable">{{ this.profile.email }}</span>
      </div>
      <div class="mb-3">
        <span class="lable">Nomor HP</span>
        <span class="valueLable">{{ this.profile.mobileNo }}</span>
      </div>
      <div class="mb-3">
        <span class="lable">Alamat</span>
        <span class="valueLable">{{ this.profile.address }}</span>
      </div>
    </div>

    <div class="mt-2">
      <button class="changePass mx-auto" @click="toChangePass">Ubah Password</button>
    </div>
  </div>
</template>

<script>
// import dateFormat from "dateformat";
import { mapActions, mapState } from "vuex";
export default {
  name: "Profile",
  data() {
    return {};
  },
  methods: {
    ...mapActions(["changeTitleApp", "editProfile", "getProfile"]),
    loadProfile: function() {
      this.getProfile()
        .then((response) => {
          this.$helpers.handleSuccess(response);
        })
        .catch((error) => {
          this.$helpers.handleError(error);
        });
    },
    toChangePass() {
      this.$router.push({ name: "changePass" });
    },
  },
  created() {
    this.changeTitleApp("Akun Saya");
  },
  computed: {
    ...mapState(["profile", "vaInfo", "banks"]),
    dob: function() {
      return this.profile.birthDt
        ? this.$moment.utc(this.profile.birthDt).format("DD MMM YYYY")
        : "";
    },
  },
  mounted() {
    this.loadProfile();
  },
};
</script>

<style scoped src="./Profile.scss" lang="scss" />
